import * as React from "react";
import { linksOf, request } from "../../../../services/cpln";
import { formSetValue, formTriggerValidation, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { ContainerInput } from "../../../../schema/types/workload/input";
import { useDebounce } from "../../../../components/table/useDebounce";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { parseLink } from "../../../../utils/linkParser/linkParser";

export const ImageProcessor: React.FC = () => {
  const { id } = useCpFormContext();
  const containers: ContainerInput[] = useCpFormValue(`containers`);
  const [debouncedContainers, setDebouncedContainers] = useDebounce(containers, 200);

  React.useEffect(() => {
    setDebouncedContainers(containers);
  }, [containers]);

  React.useEffect(() => {
    processImages();
  }, [debouncedContainers]);

  async function processImages() {
    for (const containerIndexStr in containers) {
      const containerIndex = Number(containerIndexStr);
      const container = containers[containerIndex];
      if (container.image.isExternal || !container.image.cplnValue || !container.image.cplnValue.link) {
        continue;
      }

      // Skip if fetch already attempted
      if (container.image.cplnFetchAttempted) {
        continue;
      }

      // Skip if item exists AND its link matches the container's link (not stale)
      if (container.image.cplnValue.item) {
        const itemLink = linksOf(container.image.cplnValue.item).self;
        if (itemLink === container.image.cplnValue.link) {
          continue; // Item is valid for current link
        }
        // Item is stale (from previous selection), proceed to fetch
      }

      // Skip fetching for images from saved workloads - trust existing data
      if (container.image.isFromSavedWorkload) {
        continue;
      }

      try {
        const parsedLink = parseLink(container.image.cplnValue.link, { useInputCtx: true });
        const fetchUrl = parsedLink.isValid ? parsedLink.absolute : container.image.cplnValue.link;
        const { data } = await request({ url: fetchUrl });
        formSetValue(id, `containers.${containerIndex}.image.cplnValue.item`, data);
      } catch (e) {
        // Fetch failed, item remains null
      }

      // Mark as fetch attempted after the request completes (success or failure)
      formSetValue(id, `containers.${containerIndex}.image.cplnFetchAttempted`, true);
    }

    setTimeout(() => {
      formSetValue(id, `meta.initialImageFetchIsDone`, true);
      setTimeout(() => {
        formTriggerValidation(id);
      }, 0);
    }, 0);
  }

  return null;
};
